// Angular Files
import { Component } from '@angular/core';

@Component({
    selector: 'teller-online-icon-apple-pay-mark',
    templateUrl: '../svgs/ApplePayMark.svg',
    host: { class: 'teller-online-icon teller-online-icon--apple-pay-mark' },
    standalone: false
})
export class TellerOnlineIconApplePayMarkComponent {}
